module.exports = __webpack_public_path__ + "img/guidance.0f0633f9.png";